import { GItem } from "./GItem";
import { Item } from "./Item";
import { SItem } from './SItem';
import { CommonFunctions } from "../static/common-functions";
import { PersonSel } from "./PersonSelBus";

export class InventoryReference {
    constructor(data: InventoryReference = null) {
        if (data !== null) {

            this.inventoryTypes = data.inventoryTypes;
            this.inventoryCategories = data.inventoryCategories;
            this.inventorySubCategories = data.inventorySubCategories;
            this.manufacturerTypes = data.manufacturerTypes;
            this.manufacturers = data.manufacturers;
            this.accounts = data.accounts;
            this.inventoryLocations = data.inventoryLocations;
            this.suppliers = data.suppliers;
            this.personsSel = data.personsSel;
            this.cycleCountClasses = data.cycleCountClasses;
            this.inventoryPhotoCategory = data.inventoryPhotoCategory;
            this.branchs = data.branchs;
            this.pricingTypes = data.pricingTypes;
        }
    }
    branchs: GItem[] | null = null;
    inventoryTypes: GItem[] | null = null;
    inventoryCategories: GItem[] | null = null;
    inventorySubCategories: GItem[] | null = null;
    manufacturerTypes: GItem[] | null = null;
    manufacturers: GItem[] | null = null;
    accounts: GItem[] | null = null;
    inventoryLocations: GItem[] | null = null;
    suppliers: GItem[] | null = null;
    cycleCountClasses: GItem[] | null = null;
    inventoryPhotoCategory: GItem[] | null = null;
    personsSel: PersonSel[] | null;
    pricingTypes: GItem[] | null = null;

    get hasData(): boolean {
        return this.inventoryTypes?.length > 0 ||
            this.inventoryCategories?.length > 0 ||
            this.inventorySubCategories?.length > 0 ||
            this.manufacturerTypes?.length > 0 ||
            this.manufacturers?.length > 0 ||
            this.accounts?.length > 0 ||
            this.inventoryLocations?.length > 0 ||
            this.suppliers?.length > 0 ||
            this.personsSel?.length > 0 ||
            this.cycleCountClasses?.length > 0 ||
            this.inventoryPhotoCategory?.length > 0 ||
            this.branchs?.length > 0 ||
            this.pricingTypes?.length > 0;
    }
    getUser(id: any): string {
        if (this.hasData && id && this.personsSel) {
            let item = this.personsSel.find(a => a.userId === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getPerson(id: any): string {
        if (this.hasData && id && this.personsSel) {
            let item = this.personsSel.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getSupplier(id: any): string {
        if (this.hasData && id && this.suppliers) {
            let item = this.suppliers.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getInventorySubCategories(id: any): string {
        if (this.hasData && id && this.inventorySubCategories) {
            let item = this.inventorySubCategories.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getSubCategoryPriceTypes(id: any): string {
        if (this.hasData && id && this.pricingTypes) {
            let item = this.pricingTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getInventoryLocation(id: any): string {
        if (this.hasData && id && this.inventoryLocations) {
            let item = this.inventoryLocations.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getBranch(id: any): string {
        if (this.hasData && id && this.inventoryLocations) {
            let item = this.branchs.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getManufacturer(id: any): string {
        if (this.hasData && id && this.manufacturers) {
            let item = this.manufacturers.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
}
